import type { DroneAlertThresholds, PlatformSettings } from './types';

/**
 * 平台默认告警阈值。
 * 保守取值，面向「监管」场景：宁可早报，不可漏报。
 */
export const DEFAULT_THRESHOLDS: DroneAlertThresholds = {
  batteryPercentCaution: 35,
  batteryPercentWarning: 25,
  batteryPercentCritical: 15,

  cellVoltageCaution: 3.6,
  cellVoltageWarning: 3.5,
  cellVoltageCritical: 3.4,

  satellitesCaution: 10,
  satellitesWarning: 7,
  satellitesCritical: 5,

  hdopCaution: 1.5,
  hdopWarning: 2.5,
  hdopCritical: 4,

  opticalFlowCaution: 50,
  opticalFlowWarning: 30,
  opticalFlowCritical: 15,

  linkQualityCaution: 60,
  linkQualityWarning: 40,
  linkQualityCritical: 20,

  latencyCaution: 150,
  latencyWarning: 300,
  latencyCritical: 600,

  attitudeCaution: 25,
  attitudeWarning: 35,
  attitudeCritical: 45,

  batteryTempCaution: 55,
  batteryTempWarning: 65,
  batteryTempCritical: 75,
};

export const DEFAULT_SETTINGS: PlatformSettings = {
  platformName: 'Havorix 无人机运营监管平台',
  // 机体 MAVLink 数据更新率的硬约定是 1Hz（见 docs/drone-api.md）。
  // 平台侧把频率调到更高只会拿到重复帧，因此三项默认值都对齐 1Hz：
  // 想要更顺滑的轨迹观感应当在前端插值，而不是要求机体提速上报。
  overviewTelemetryRateHz: 1,
  singleDroneTelemetryRateHz: 1,
  defaultTelemetryRateHz: 1,
  defaultStaleAfterMs: 3000,
  defaultThresholds: DEFAULT_THRESHOLDS,
  auditRetentionDays: 180,
  allowDroneProbe: false,
};

/** 遥测频率的允许区间，前后端共用，避免出现 0Hz 或打爆链路的配置。 */
export const TELEMETRY_RATE_MIN_HZ = 0.2;
export const TELEMETRY_RATE_MAX_HZ = 50;

export const STALE_AFTER_MIN_MS = 500;
export const STALE_AFTER_MAX_MS = 60_000;

/** 把局部阈值覆盖合并到默认阈值上。 */
export function resolveThresholds(
  overrides: Partial<DroneAlertThresholds> | null | undefined,
  base: DroneAlertThresholds = DEFAULT_THRESHOLDS,
): DroneAlertThresholds {
  if (!overrides) return { ...base };
  const merged: DroneAlertThresholds = { ...base };
  for (const [key, value] of Object.entries(overrides)) {
    if (typeof value === 'number' && Number.isFinite(value) && key in merged) {
      merged[key as keyof DroneAlertThresholds] = value;
    }
  }
  return merged;
}
